// Auto-deployment hook for blog posts
// Import this in your blog creation/admin components

export const useAutoDeployment = () => {
  const triggerDeployment = async (blogData: {
    id: string;
    title: string;
    action: "created" | "updated" | "deleted";
  }) => {
    try {
      console.log(`📝 Blog ${blogData.action}: ${blogData.title}`);

      // Call your workflow API endpoint
      const response = await fetch("/api/rebuild-blogs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer cittasya-blog-rebuild-2025`, // Your secret
        },
        body: JSON.stringify({
          blogId: blogData.id,
          action: blogData.action,
          title: blogData.title,
          timestamp: new Date().toISOString(),
        }),
      });

      if (response.ok) {
        console.log("✅ Auto-deployment triggered successfully");

        // Optional: Show user notification
        if (typeof window !== "undefined" && "Notification" in window) {
          if (Notification.permission === "granted") {
            new Notification("Blog Published! 🎉", {
              body: "Your blog post is being deployed. It will be live in 2-3 minutes.",
              icon: "/cittasya-logo.svg",
            });
          }
        }

        return { success: true };
      } else {
        console.warn("⚠️ Auto-deployment failed, but blog was saved");
        return { success: false, error: "Deployment failed" };
      }
    } catch (error) {
      console.error("💥 Auto-deployment error:", error);
      return { success: false, error: error.message };
    }
  };

  return { triggerDeployment };
};
